import { useEffect, useState } from "react";

export type NetworkType = "wifi" | "cellular" | "unknown";

/**
 * Hook zur Erkennung des Netzwerk-Typs (WiFi vs. Mobilfunk)
 * Nutzt die Network Information API für Smart Quality Selection
 */
export function useNetworkType(): NetworkType {
  const [networkType, setNetworkType] = useState<NetworkType>("unknown");

  useEffect(() => {
    // Network Information API (Chrome/Edge/Opera)
    const connection =
      (navigator as any).connection ||
      (navigator as any).mozConnection ||
      (navigator as any).webkitConnection;

    if (!connection) {
      setNetworkType("unknown");
      return;
    }

    const updateNetworkType = () => {
      if (connection.saveData) {
        setNetworkType("cellular");
        return;
      }

      const connType = connection.type as string | undefined;
      if (connType === "cellular") {
        setNetworkType("cellular");
        return;
      }
      if (
        connType === "wifi" ||
        connType === "ethernet" ||
        connType === "wimax"
      ) {
        setNetworkType("wifi");
        return;
      }

      const type = connection.effectiveType; // '4g', '3g', '2g', 'slow-2g'
      if (type === "2g" || type === "slow-2g") {
        setNetworkType("cellular");
        return;
      }
      if (type === "4g" || type === "3g") {
        // Heuristik: downlink > 5 Mbps → oft WLAN / gutes Festnetz
        setNetworkType(connection.downlink > 5 ? "wifi" : "cellular");
        return;
      }
      setNetworkType("unknown");
    };

    updateNetworkType();
    connection.addEventListener("change", updateNetworkType);
    return () => connection.removeEventListener("change", updateNetworkType);
  }, []);

  return networkType;
}
